import { useCallback } from 'react';

import { usePetitionActionsPageState } from '#src/app/pages/actions/pageContext';
import { useSupporterVoicesVideoFirstTrackingProps } from '#src/app/pages/actions/shared/hooks';
import { useCampaignTracking } from '#src/app/shared/hooks/campaignTracking';

import { useVideoRecorderActions } from '../../../../../../shared/hooks/useVideoRecorderActions';

type Result = ModelHookResult<
	EmptyObject,
	{
		handleButtonClick: () => void;
	}
>;

export function useOpenCameraButton(): Result {
	const [{ shareSupporterVoiceSuccess }, { setShareSupporterVoiceSuccess }] = usePetitionActionsPageState();

	const {
		actions: { prepareCamera },
	} = useVideoRecorderActions();
	const { track } = useCampaignTracking();
	const trackingProps = useSupporterVoicesVideoFirstTrackingProps();

	const handleButtonClick = useCallback(() => {
		track('campaign_action_create_video_add_video_click', {
			source: shareSupporterVoiceSuccess ? 'campaign_action_supporter_voice_success' : 'campaign_action_landing',
			...trackingProps,
		});

		setShareSupporterVoiceSuccess(false);

		prepareCamera();
	}, [track, prepareCamera, shareSupporterVoiceSuccess, setShareSupporterVoiceSuccess, trackingProps]);

	return {
		data: {},
		actions: {
			handleButtonClick,
		},
	};
}
